module.exports = __webpack_public_path__ + "img/blue_dance.9896ab87.png";